import Header from '@custom/Header/Header'
import { customStyle } from '@custom/Utils/utils'
import React, { useRef, useState } from 'react';
import { useTheme } from '../../ui/src/contextProviders'
import GraphForm from './GraphForm';
import TabularForm from './TabularForm';

const Analytics = () => {
  const currentYear = new Date().getFullYear();
  const { isDarkMode } = useTheme();
  const [view, setView] = useState('graph');
  const [selectedYear, setSelectedYear] = useState<number>(currentYear)


  return (
    <div className='page page__full' style={
      isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    }>
      <Header title={'Analytics'} isBack={false} />
      <div className='page__body'>
        <div className="details">
          <div className='w-100 border-red-300 flex justify-between items-center'>
            <div>Executive Summary</div>
            <div className='flex'>
              <div>
                <select id="year-select" className="year-dropdown" value={selectedYear}  onChange={(e) => setSelectedYear(Number(e.target.value))}>
                  {Array.from({ length: currentYear - 1945 + 1 }, (_, index) => 1945 + index).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <span className='flex gap-2.5 justify-center items-center ml-3'>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="graph"
                      checked={view == 'graph'}
                      onChange={() => setView('graph')}
                    />
                    <span className="ml-1">Graph</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="tabular"
                      checked={view == 'tabular'}
                      onChange={() => setView('tabular')}
                    />
                    <span className="ml-1">Tabular</span>
                  </label>
                </span>
              </div>
            </div>
          </div>
          <div className="mt-6">
            {view === 'graph' ? (
              <GraphForm selectedYear={selectedYear} />
            ) : (
              <TabularForm selectedYear={selectedYear} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Analytics
